import React from 'react';
import { AlertCircle } from 'lucide-react';

/**
 * ValidatedTextarea - Reusable textarea component with validation error display
 */
const ValidatedTextarea = ({
  name,
  label,
  register,
  errors,
  placeholder,
  className = '',
  required = false,
  disabled = false,
  rows = 4,
  ...rest
}) => {
  const hasError = errors && errors[name];
  const errorMessage = hasError ? errors[name].message : null;

  return (
    <div className={`validated-input-wrapper ${className}`}>
      {label && (
        <label 
          htmlFor={name} 
          className="validated-input-label"
        >
          {label}
          {required && <span className="required-indicator"> *</span>}
        </label>
      )}
      
      <textarea
        id={name}
        {...register(name)}
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
        className={`validated-textarea ${hasError ? 'input-error' : ''}`}
        aria-invalid={hasError ? 'true' : 'false'}
        aria-describedby={hasError ? `${name}-error` : undefined}
        {...rest}
      />

      {hasError && (
        <div 
          id={`${name}-error`}
          className="validation-error"
          role="alert"
        >
          <AlertCircle className="error-icon" />
          <span className="error-message">{errorMessage}</span>
        </div>
      )}
    </div>
  );
};

export default ValidatedTextarea;

